<kendo-window
  class="customFieldsWindow"
  title="Edit Records"
  style="z-index: 10050;"
  (close)="closeForm($event)"
  >
  <div class="container-fluid">
    <div class="row special_row_margin">
      <div class="col-12 special_col_padding">
        <div class="border_sections margin-top-4">
          <div class="row" style="margin: 0">
            <div class="col-12">
              <h2 class="formsTitle">Edit Forms</h2>
              <div class="margin">
                <button
                  kendoButton
                  class="steps_buttons_class mr-0"
                  (click)="closeForm(false)"
                  >
                  <img
                    class="backimage"
                    [src]="'/assets/menu/' + _theme + '/close-schedule-report-icon-green.svg'"
                    />
                    <span>Close</span>
                  </button>
                  <button
                    kendoButton
                    class="steps_buttons_class mr-0"
                    (click)="submit()"
                    >
                    <img
                      class="backimage"
                      [src]="'/assets/menu/' + _theme + '/save-icon-group.svg'"
                      />
                      <span>Save & Close</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="formsMenuSeparator"></div>
                </div>
              </div>
              <div class="row m-0">
                <div
                  class="col-2 pt-2 pb-2 tabcontentTitle"
                  style="border-right: 1px solid #e9ecef"
                  >
                  <span> Tab Name </span>
                </div>
                <div
                  class="col-4 d-flex pt-2 pb-2"
                  style="border-right: 1px solid #e9ecef"
                  >
                  <div class="row m-0" style="width: -webkit-fill-available">
                    <div class="col-9 align-self-start tabcontentTitle">
                      Tab Access
                    </div>
                    <div class="col-3 align-self-end">
                      <div class="row justify-content-end view-edit-font">View</div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-2 pt-2 pb-2 tabcontentTitle"
                  style="border-right: 1px solid #e9ecef"
                  >
                  <span> Field Name </span>
                </div>
                <div class="col-4 d-flex pt-2 pb-2">
                  <div class="row m-0" style="width: -webkit-fill-available">
                    <div class="col-8 align-self-start tabcontentTitle">
                      Field Access
                    </div>
                    <div class="col-4 align-self-end">
                      <div class="row justify-content-end">
                        <div class="col-6 view-edit-font">View</div>
                        <div class="col-6 view-edit-font">Edit</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              @for (obj of object; track obj) {
                <div class="row m-0">
                  <div
                    class="row m-0 tabName"
                    style="background-color: #e9ecef; width: -webkit-fill-available"
                    >
                    <div class="col-12">
                      <div class="formsMenuSeparator"></div>
                    </div>
                    <div class="col-12 role-font">
                      {{ obj.name }}
                    </div>
                    <div class="col-12">
                      <div class="formsMenuSeparator"></div>
                    </div>
                  </div>
                  <div class="row m-0" style="width: -webkit-fill-available">
                    <div class="col-2" style="border-right: 1px solid #e9ecef"></div>
                    <div class="col-4" style="border-right: 1px solid #e9ecef">
                      @for (sec of obj?.formTabAuthorizations; track sec) {
                        <div
                          class="row m-0 pt-2 pb-2"
                          >
                          <div class="col-9 align-self-start role-font">
                            {{ sec?.appRole?.name }}
                          </div>
                          <div class="col-3 align-self-end">
                            <div class="row justify-content-end">
                              <div class="col-12 p-0" style="text-align: end">
                                <input
                                  type="checkbox"
                                  [(ngModel)]="sec.canView"
                                  class="k-checkbox"
                                  kendoCheckBox
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="col-6 p-0">
                        @for (field of obj?.gridFieldDefinitions; track field) {
                          @if (!field.isCustomField && field.gridFieldText && field.gridFieldText.currentText) {
                            <div
                              class="row m-0"
                              style="border-bottom: 1px solid #e9ecef"
                              >
                              <div class="col-4" style="border-right: 1px solid #e9ecef">
                                <div class="row m-0 pt-2 role-font">
                                  {{ field?.gridFieldText?.currentText }}
                                </div>
                              </div>
                              <div class="col-8">
                                @for (sec of field?.gridFieldAuthorizations; track sec) {
                                  <div
                                    class="row m-0 pt-2 pb-2"
                                    >
                                    <div class="col-8 align-self-start role-font">
                                      {{ sec?.appRole?.name }}
                                    </div>
                                    <div class="col-4 align-self-end">
                                      <div class="row">
                                        @if (canSetSecurityLevel('read', sec.appRole)) {
                                          <div
                                            class="col-6"
                                            >
                                            <input
                                              type="checkbox"
                                              [disabled]="$safeNavigationMigration(field?.gridFieldText?.isRequired)"
                                (ngModelChange)="
                                  CheckBoxOnViewChange(sec, $event)
                                "
                                              [(ngModel)]="sec.canView"
                                              class="k-checkbox"
                                              kendoCheckBox
                                              />
                                            </div>
                                          }
                                          @if (
                                            canSetSecurityLevel('update', sec.appRole) ||
                                            canSetSecurityLevel('create', sec.appRole)
                                            ) {
                                            <div
                                              class="col-6"
                                              >
                                              <input
                                                type="checkbox"
                                                [disabled]="$safeNavigationMigration(field?.gridFieldText?.isRequired)"
                                (ngModelChange)="
                                  CheckBoxOnEditChange(sec, $event)
                                "
                                                [(ngModel)]="sec.canEdit"
                                                class="k-checkbox"
                                                kendoCheckBox
                                                />
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                            }
                            @for (field of obj?.customFields; track field) {
                              <div
                                class="row m-0"
                                style="border-bottom: 1px solid #e9ecef"
                                >
                                <div class="col-4" style="border-right: 1px solid #e9ecef">
                                  <div class="row m-0 pt-2 role-font">
                                    {{ field?.name }}
                                  </div>
                                </div>
                                <div class="col-8">
                                  @for (
                                    sec of field?.gridFieldDefinition
                                    ?.gridFieldAuthorizations
                                    ; track
                                    sec) {
                                    <div
                                      class="row m-0 pt-2 pb-2"
                                      >
                                      <div class="col-8 align-self-start role-font">
                                        {{ sec?.appRole?.name }}
                                      </div>
                                      <div class="col-4 align-self-end">
                                        <div class="row">
                                          @if (canSetSecurityLevel('read', sec.appRole)) {
                                            <div
                                              class="col-6"
                                              >
                                              <input
                                                type="checkbox"
                              (ngModelChange)="
                                CheckBoxOnViewChange(sec, $event)
                              "
                                                [(ngModel)]="sec.canView"
                                                class="k-checkbox"
                                                kendoCheckBox
                                                />
                                              </div>
                                            }
                                            <!-- [disabled]="field?.gridFieldText?.isRequired" -->
                                            @if (
                                              canSetSecurityLevel('update', sec.appRole) ||
                                              canSetSecurityLevel('create', sec.appRole)
                                              ) {
                                              <div
                                                class="col-6"
                                                >
                                                <input
                                                  type="checkbox"
                              (ngModelChange)="
                                CheckBoxOnEditChange(sec, $event)
                              "
                                                  [(ngModel)]="sec.canEdit"
                                                  class="k-checkbox"
                                                  kendoCheckBox
                                                  />
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row card bottom-row pt-3"></div> -->
                </div>
              </kendo-window>
